import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Assets/Css/home.css';
import { Container, Row, Col, Card } from 'react-bootstrap';



import aboutimg from '../Assets/Image/pradhservices.png'
import ctaimg from '../Assets/Image/ctaimg1.avif'
import { FaTools, FaBroom, FaClipboardList } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

import slide1 from '../Assets/Image/homebannerimg1.jpg'
import slide2 from '../Assets/Image/homebannerimg.avif'
import slide3 from '../Assets/Image/pradhservices.png'
import slide4 from '../Assets/Image/slide4.avif'

import cleaningImg from '../Assets/Image/cleaning.jpg'
import maintenanceImg from '../Assets/Image/maintenance.avif'
import constructionImg from '../Assets/Image/Commercial Industrial Civil1.avif'
import mepImg from '../Assets/Image/mepservices1.avif'
import paintingImg from '../Assets/Image/painting.avif'
import pestcontrolImg from '../Assets/Image/pestcontrol.avif'
import manpowerImg from '../Assets/Image/manpowerhousekeeping.avif'
import fabricationImg from '../Assets/Image/fabrication.avif'


import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export default function HomePage() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [aosKey, setAosKey] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    setTimeout(() => {
      AOS.refresh();
      setAosKey(k => k + 1);
    }, 100);
  }, []);


  const slides = [
    {
      image: slide1,
      maintitle: 'Pradh',
      title: 'Management Solutions',
      description: 'Complete infrastructure and facility services for industrial and commercial sectors.',
    },
    {
      image: slide2,
      title: 'Expert Facility Services<br />with <span class="pradhtitle">Pradh</span>',
      description: 'Specialized in HVAC, fire safety, pest control, waterproofing, and painting.',
    },

    {
      image: slide3,
      title: 'Operational Excellence<br />Powered by <span class="pradhtitle">Pradh</span>',
      description: 'Manpower, housekeeping, and fabrication services for smooth operations.',
    },
    {
      image: slide4,
      title: 'Your Infrastructure.<br />Our Responsibility with <span class="pradhtitle">Pradh</span>',
      description: 'Reliable maintenance and hygiene solutions to keep your facility running safely.',
    },
  ];

  const servicesData = [
    { title: "Cleaning Services", img: cleaningImg },
    { title: "Maintenance Services", img: maintenanceImg },
    { title: "Civil & Construction", img: constructionImg },
    { title: "MEP Services", img: mepImg },
    { title: "Painting & Coating", img: paintingImg },
    { title: "Pest & Bird Control", img: pestcontrolImg },
    { title: "Manpower & Housekeeping", img: manpowerImg },
    { title: "Fabrication Services", img: fabricationImg },
  ];

  const testimonials = [
    {
      message: "Pradh Management Solutions handled our high-rise glass and floor cleaning with impressive efficiency and safety protocols. Their professionalism sets them apart.",
      author: "Facility Manager – Commercial Tower"
    },
    {
      message: "From MEP maintenance to fire system installation, their team delivered quality work on time with full compliance. Excellent coordination throughout.",
      author: "Project Head – Manufacturing Unit"
    },
    {
      message: "We rely on Pradh for civil works and fabrication support. Their skilled manpower and project execution are reliable and precise.",
      author: "Operations Lead – Industrial Plant"
    },
    {
      message: "The pest control and housekeeping services from Pradh are consistent and well-managed. They maintain hygiene standards without disrupting operations.",
      author: "Admin Officer – Logistics Hub"
    }
  ];

  return (
    <>
      <div className="mainnav min-vh-100">

        <Helmet>
          {/* Basic SEO */}
          <title>Pradh Management Solutions | Facility & Infrastructure Services India</title>
          <meta
            name="description"
            content="Pradh Management Solutions offers complete industrial and commercial services in India, including cleaning, MEP, pest control, fabrication, civil work, and more."
          />
          <meta
            name="keywords"
            content="Facility management India, Pradh, Industrial services, Commercial cleaning, MEP solutions, Fabrication, Manpower, Housekeeping, Pest control, Waterproofing, HVAC, Painting, Civil construction"
          />
          <meta name="author" content="Pradh Management Solutions" />
          <meta name="robots" content="index, follow" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Pradh Management Solutions | Facility & Infrastructure Experts" />
          <meta
            property="og:description"
            content="Reliable facility and infrastructure management services including cleaning, HVAC, fire safety, painting, fabrication, and manpower support."
          />
          <meta property="og:url" content="https://pradh.com/" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://pradh.com/images/logo.png" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Pradh Management Solutions | Facility & Infra Experts" />
          <meta
            name="twitter:description"
            content="Industrial and commercial facility services including housekeeping, civil, pest control, fabrication, MEP, and more across India."
          />
          <meta name="twitter:image" content="https://pradh.com/images/logo.png" />

          {/* Canonical URL */}
          <link rel="canonical" href="https://pradh.com/" />
        </Helmet>

        {/* Hero Section */}
        <section className="hero-slider">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            loop={true}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.realIndex);
              AOS.refresh();
            }}
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>

                <div className="slide-content">
                  <div
                    className="slide-bg"
                    style={{ backgroundImage: `url(${slide.image})` }}
                  ></div>
                  <div className="overlay-content" key={`${activeIndex}-${aosKey}`}>

                    <h1 className='maintitle' data-aos="fade-up" data-aos-delay="100">
                      {slide.maintitle}
                    </h1>

                    <h2
                      data-aos="fade-up"
                      data-aos-delay="100"
                      dangerouslySetInnerHTML={{ __html: slide.title }}

                    >
                    </h2>

                    <p data-aos="zoom-in" data-aos-delay="300">{slide.description}</p>
                    <a href="/contact" className="btn-donate" data-aos="zoom-in" data-aos-delay="500">
                      Contact Now
                    </a>
                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        {/* About Section Preview */}
        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={6}>
                <h2 className='page-title' data-aos="fade-up" > About Us </h2>
                <div style={{ textAlign: 'justify' }} data-aos="zoom-in" data-aos-delay="200">
                  <p>
                    <strong style={{ color: '#04A1D3' }}> Pradh Management Solutions</strong> is a leading provider of integrated industrial and commercial services across India. With a strong focus on quality, safety, and reliability, we deliver specialized solutions tailored to meet the operational needs of businesses, institutions, and infrastructure facilities.
                  </p>
                </div>

                <div className="text-center">
                  <a href="/aboutus" className="btn-learn mb-4" data-aos="zoom-in">Learn More</a>
                </div>
              </Col>

              {/* Image Section */}
              <Col md={6}>
                <div className="d-flex justify-content-center">
                  <img
                    src={aboutimg}
                    alt="Teamwork and Services"
                    className="img-fluid aboutimg rounded shadow"
                    data-aos="zoom-in"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Container className="py-3">
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="who-we-are-section p-5 ">
                <h2 className="page-title" data-aos="fade-up">Who We Are</h2>
                <p className="text-center text-dark">
                  <strong>Pradh Management Solutions</strong> is a multi-disciplinary service provider committed to delivering end-to-end infrastructure support across industrial and commercial sectors. With a deep understanding of facility management, civil execution, and operational support, we combine skilled manpower with modern tools to ensure efficiency, safety, and excellence on every project.
                </p>

                <h5 className="mt-4 fw-semibold"> We specialize in:</h5>
                <ul className="custom-list1 mt-3">
                  <li>
                    <FaTools className="me-2 text-primary  responsive-icon" />
                    Structural fabrication, industrial shed erection, NH/SH road gantries, and pre-engineered building works.
                  </li>
                  <li>
                    <FaBroom className="me-2 text-success  responsive-icon" />
                    Mechanized housekeeping, pest control, lift maintenance, security, and manpower deployment for routine operations.
                  </li>
                  <li>
                    <FaClipboardList className="me-2 text-warning  responsive-icon" />
                    Turnkey facility services executed with full compliance to industry safety and quality standards.
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>


        {/* Services Summary */}

        <section className="services-summary py-4 mb-4">
          <Container>
            <h2 className='page-title' data-aos="fade-up"> Our Services </h2>
            <Row className="gx-3 mt-4">
              {servicesData.map((service, index) => (
                <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-3" data-aos="flip-up"
                  data-aos-delay={index * 100 + 200}>
                  <Card className="h-100 sevicecard">
                    <Card.Img
                      variant="top"
                      src={service.img}
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <Card.Body className="text-center servicecardbg">
                      <h5>{service.title}</h5>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="cta-section text-white py-4">
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <div className="d-flex justify-content-center" data-aos="zoom-in">
                  <img
                    src={ctaimg}
                    alt="Pradh service team in action"
                    className="img-fluid ctaimg rounded shadow mb-2"
                  />
                </div>
              </Col>
              <Col md={6} className="text-center text-md-start" data-aos="zoom-in">
                <h2>Need Professional Support for Your Infrastructure?</h2>
                <p className="lead">
                  From industrial cleaning and civil work to MEP installations and skilled manpower — <strong>Pradh Management Solutions</strong> delivers safe, timely, and efficient services tailored to your facility needs.
                </p>
                <a href="/contact" className="btn-learn mt-3" data-aos="fade-up">Get in Touch Today</a>
              </Col>
            </Row>
          </Container>
        </section>


        <section className="testimonials py-5 bg-light">
          <Container>
            <h2 className="page-title text-center " data-aos="fade-up"> What Our Clients Say </h2>
            <Row>
              <Col md={{ span: 8, offset: 2 }} >
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 5000 }}
                  loop={true}
                  pagination={{ clickable: true }}
                >
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <Card className="p-4 mb-4  border-0" data-aos="zoom-in">
                        <p className="star-rating">⭐️⭐️⭐️⭐️⭐️</p>

                        <p className="mb-3 " style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>

                        <small className="text-muted">— {testimonial.author}</small>

                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
